/* __next_internal_client_entry_do_not_use__ SDUIOnViewHandler auto */ import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSDUIActionsHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/ActionHandler/useSDUIActionsHandler";
import { logLegacyViewEvent as logLegacyViewEventHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/EventLogging/logLegacyViewEvent";
import { logSDUIEvent } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/EventLogging/logSDUIEvent";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { FilterablePaginatedSectionContext } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionContext";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useIntersectionObserver } from "@faire/web--source/ui/hooks/useIntersectionObserver";
import { useMergedRefs } from "@faire/web--source/ui/hooks/useMergedRefs";
import React, { useContext } from "react";
export var SDUIOnViewHandler = function(param) {
    var ref = param.ref, className = param.className, componentStyle = param.componentStyle, children = param.children, loggingData = param.loggingData, onViewActions = param.onViewActions, logSDUIViewEvent = param.logSDUIViewEvent, logLegacyViewEvent = param.logLegacyViewEvent, shouldSetIsScrollingTopToFalseOnView = param.shouldSetIsScrollingTopToFalseOnView, ariaHidden = param.ariaHidden;
    var setIsScrollingToTop = useContext(FilterablePaginatedSectionContext).setIsScrollingToTop;
    var actionsHandler = useSDUIActionsHandler(onViewActions, loggingData);
    var viewRef = useIntersectionObserver(function(entry) {
        if (!entry.isIntersecting) {
            return;
        }
        actionsHandler();
        if (logSDUIViewEvent && loggingData.view_display_page) {
            logSDUIEvent("VIEW", loggingData);
        }
        if (shouldSetIsScrollingTopToFalseOnView) {
            setIsScrollingToTop === null || setIsScrollingToTop === void 0 ? void 0 : setIsScrollingToTop(false);
        }
    }, {
        threshold: 0,
        rootMargin: "0px"
    });
    var legacyViewEventRef = useDoActionWhenVisible(function() {
        if (logLegacyViewEvent && "component_name" in loggingData && loggingData.component_name && loggingData.view_display_page) {
            var componentName = loggingData.component_name;
            var _loggingData_request_id;
            var requestId = (_loggingData_request_id = loggingData.request_id) !== null && _loggingData_request_id !== void 0 ? _loggingData_request_id : "";
            var _loggingData_action_content;
            var actionContent = "action_content" in loggingData ? (_loggingData_action_content = loggingData.action_content) !== null && _loggingData_action_content !== void 0 ? _loggingData_action_content : "" : "";
            logLegacyViewEventHandler(loggingData.view_display_page, {
                componentName: componentName,
                requestId: requestId,
                actionContent: actionContent
            });
        }
    });
    var refsToMerge = [
        ref
    ];
    if (logSDUIViewEvent || onViewActions.length > 0 || shouldSetIsScrollingTopToFalseOnView) {
        refsToMerge.push(viewRef);
    }
    var validLegacyViewEventConditions = logLegacyViewEvent && "component_name" in loggingData && loggingData.component_name && loggingData.view_display_page;
    if (validLegacyViewEventConditions) {
        refsToMerge.push(legacyViewEventRef);
    }
    var mergedRefs = useMergedRefs.apply(void 0, _to_consumable_array(refsToMerge));
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        style: componentStyle,
        ref: mergedRefs,
        "aria-hidden": ariaHidden === "true",
        children: children
    });
};
